<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="ibox">
                <div class="ibox-title">
                  <el-form id="elForm" :inline="true" :model="formInline" ref="formInline" label-width="85px" label-position="right" class="demo-form-inline" size="medium">
                    <el-form-item label="学年：" prop="classYear">
                        <el-select v-model="formInline.classYear" placeholder="请选择学年" @change="changeYear">
                            <el-option v-for="item in yearList" :key="item.yearName" :label="item.yearName" :value="item.yearName"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="市：" prop="cityID" v-show="show.selCity">
                      <el-select v-model="formInline.cityID" placeholder="请选择市" @change="selectChange(1,formInline.cityID)">
                        <el-option v-for="item in selectcity" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="区县：" prop="countryID" v-show="show.selCountry">
                      <el-select v-model="formInline.countryID" placeholder="请选择区" @change="selectChange(2,formInline.countryID)">
                        <el-option v-for="item in selectarea" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="幼儿园：" prop="gardenId">
                        <el-select v-model="formInline.gardenId" placeholder="请选择幼儿园" filterable>
                            <el-option v-for="item in selectGarden" :key="item.orgKindID" :label="item.fullName" :value="item.orgKindID"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="体检类型：" prop="mecType">
                        <el-select v-model="formInline.mecType" placeholder="请选择体检类型">
                            <el-option v-for="item in mecTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="姓名：" prop="childName">
                        <el-input v-model="formInline.childName" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="体检日期：" prop="phyDate">
                        <el-date-picker v-model="phyDate" type="daterange" align="right" @change="changePhy"
                        placeholder="选择日期范围" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="btn-primary" @click="onSubmit(formInline)">查询</el-button>
                        <el-button class="btn-default" @click="onReset('formInline')">重置</el-button>
                    </el-form-item>
                  </el-form>
                    <div>
                        <el-table ref="multipleTable" id="tableList" class="table-bordered" :data="tableData" :loading="false" element-loading-text="拼命加载中" bordertooltip-effect="dark" style="width: 100%">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="childName" label="姓名"></el-table-column>
                            <el-table-column prop="sex" label="性别"></el-table-column>
                            <el-table-column prop="birthday" label="生日" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="age" label="年龄(岁.月)" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="idCard" label="身份证号码" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="gardenName" label="幼儿园" show-overflow-tooltip> </el-table-column>
                            <el-table-column prop="mecTypeName" label="体检类型" show-overflow-tooltip> </el-table-column>
                            <el-table-column prop="checkDate" label="体检日期" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="heightValue" label="身高(cm)" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="heightComment" label="身高评价" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="weightValue" label="体重(kg)" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="weightComment" label="体重评价" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="overallComment" label="综合评价" show-overflow-tooltip></el-table-column>
                            <el-table-column label="操作" width="170">
                            <template slot-scope="scope">
                                <!-- <el-button class="btn-warning btn-outline" @click="orgmgrDel(scope.$index,scope.row)" plain size="small">详情</el-button>
                                <el-button class="btn-primary btn-outline" @click="printShow(scope.$index,scope.row)" plain size="small">报告</el-button> -->
                                <el-button v-for='(item,index) in listArea' :key='index' class="btn-outline" @click="doClick(item.operFunc,scope.$index,scope.row)" size="small" plain>{{item.operName}}</el-button>
                            </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="formInline.pageNum" :page-sizes="[10, 25, 50, 100]" :page-size="formInline.pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total" style="margin-top: 10px;">
                    </el-pagination>
                </div>
            </div>
        </div>
      <!--彈出的详情-->
      <el-dialog title="" :visible.sync="dialogTableVisible" width="70%" :close-on-click-modal='false'>
        <router-view v-on:close="close" v-if='dialogTableVisible'></router-view>
      </el-dialog>
  </div>
</template>

<script>
import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import common from '../../com/common'
export default {
  data () {
    var that = this
    return {
      dialogTableVisible: false,
      popupMsg: false,
      phyDate: '',
      yearList: [],
      tableData: [], // 数据表数据
      formInline: {// 筛选条件表单数据
        classYear: '',
        gardenId: '',
        mecType: '',
        pageNum: 1,
        pageSize: 10,
        childName: '',
        cityID: '',
        countryID: '',
        provinceID: ''
      },
      getId: '', // 判断是不是山东账号
      show: {// 省市区显示
        selCountry: false,
        selCity: false
      },
      selectcity: [], // 筛选条件下拉框市数据
      selectarea: [], // 筛选条件下拉框区数据
      selectGarden: [{orgKindID: '', fullName: '全部'}], // 筛选条件下拉框幼儿园数据
      mecTypeList: [
        {
          name: '全部', id: ''
        },
        {
          name: '入园体检', id: '2'
        },
        {
          name: '六一体检', id: '3'
        },
        {
          name: '自定义体检', id: '1'
        }
      ],
      currentPage: 1,
      total: 0,
      pickerOptions: {
        shortcuts: [ {
          text: '过去七天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '过去30天',
          onClick (picker) {
            const end = new Date()
            const start = that.GetMonthStr(1)
          //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '过去半年',
          onClick (picker) {
            const end = new Date()
            const start = that.GetMonthStr(6)
          //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '过去一年',
          onClick (picker) {
            const end = new Date()
            const start = that.GetMonthStr(12)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      generalArea:[],
      listArea:[]
    }
  },
  methods: {
    GetMonthStr (AddMonthCount) { // 获取过去几个月
      var dd = new Date()
      dd.setMonth(dd.getMonth() - AddMonthCount)// 获取AddMonthCount月后的日期
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1// 获取当前月份的日期
      var d = dd.getDate()
      // 判断 月
      if (m < 10) {
        m = '0' + m
      } else {
        m = m
      }
      // 判断 日n
      if (d < 10) { // 如果天数<10
        d = '0' + d
      } else {
        d = d
      }
      return y + '-' + m + '-' + d
    },
    close (flag) {
      this.dialogTableVisible = flag
    },
    onSubmit (pram) { // 查询条件查询按钮点击事件
      // this.formInline.pageSize = 10
      pram.pageNum = 1
      this.getOrgList(pram)
    },
    onReset (formName) { // 查询条件重置
      this.$refs[formName].resetFields()
      this.phyDate = ''
      this.formInline.startDate = ''
      this.formInline.endDate = ''
    },
    orgmgrDel (index, row) { // 详情
    debugger
      this.dialogTableVisible = true
      this.$router.push({path: '/physical_org/detail/', query: {row: row}})
    },
    printShow (index, row) { // 打印

      let that = this
      // 先查询本报告是否购买了
      var nparm = {
        // 1 业务类型为妇保院儿童体检报告 2 妇保院端幼儿园体检报告
        'bizType': 2,
        'bizId': row.id
      }
      api.post(config.khsHost + 'support/reChargeAndConsume/getConsumeAndReCharge.do', nparm).then(function (json) {
        // 已经购买过，直接展示
        if(json.success === true && json.body.consume != undefined) {

          that.dialogTableVisible = true
          if (that.getId === 370000 || that.getId === 430000) {
            that.$router.push({path: '/physical_org/reportsSd/' + row.id, query: {row: row}})
          } else {
            that.$router.push({path: '/physical_org/reports/' + row.id, query: {row: row}})
          }

        } else if(json.body.reCharge.surplus < 2) {
          that.$confirm('当前余额：'+json.body.reCharge.surplus+'元，余额不足，请前去充值', '提示', {
                  confirmButtonText: '去充值',
                  cancelButtonText: '取消',
                  type: 'warning'
          }).then(() => {
            window.open(config.khsHost + 'h5_orgPay/payReCharge.html?token='+localStorage.getItem('Haiziguo-Token'))
          }).catch(() => {
            that.$message({
              type: 'info',
              message: '已取消去充值'
            })
          });
        } else {

          that.$confirm('当前余额：'+json.body.reCharge.surplus+'元，本报告需要付费2元，确定购买吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            nparm = {
              // 1 业务类型为妇保院儿童体检报告 2 妇保院端幼儿园体检报告
              'bizType': 2,
              'bizId': row.id,
              // 每次消费 2元
              'consume': 2
            }
            api.post(config.khsHost + 'support/reChargeAndConsume/addConsume.do', nparm).then(function (json) {
              // 购买成功展示
              if(json.success === true && json.body == 1) {

                that.dialogTableVisible = true
                if (that.getId === 370000 || that.getId === 430000) {
                  that.$router.push({path: '/physical_org/reportsSd/' + row.id, query: {row: row}})
                } else {
                  that.$router.push({path: '/physical_org/reports/' + row.id, query: {row: row}})
                }

              } else {
                that.$confirm('余额不足，请前去充值', '提示', {
                  confirmButtonText: '去充值',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  window.open(config.khsHost + 'h5_orgPay/payReCharge.html?token='+localStorage.getItem('Haiziguo-Token'))
                }).catch(() => {
                  that.$message({
                    type: 'info',
                    message: '已取消去充值'
                  })
                });
              }
            }).catch((data) => {

            });
          }).catch(() => {
            that.$message({
              type: 'info',
              message: '已取消购买'
            })
          });
        }
      })

    },
    showMsgTip (value, type) { // 提示消息
      if (type === 'false') {
        this.$message({
          message: value
        })
      } else {
        this.$message({
          message: value,
          type: type
        })
      }
    },
    imports () { // 导入
      this.dialogTableVisible = true
      this.$router.push({ path: '/teacherPhy/import' })
    },
    handleSizeChange (val) { // 分页每页条数改变事件
      this.formInline.pageSize = val
      this.getOrgList(this.formInline)
    },
    handleCurrentChange (val) { // 分页页数改变事件
      this.formInline.pageNum = val
      this.getOrgList(this.formInline)
    },
    changePhy (val) {
      if (val) {
        var d = new Date(val[0])
        var b = new Date(val[1])
        var startYouWant = d.getFullYear() + '-' + this.getDateN(d.getMonth() + 1) + '-' + this.getDateN(d.getDate())
        var endYouWant = b.getFullYear() + '-' + this.getDateN(b.getMonth() + 1) + '-' + this.getDateN(b.getDate())
        this.formInline.startDate = startYouWant
        this.formInline.endDate = endYouWant
      } else {
        this.formInline.startDate = ''
        this.formInline.endDate = ''
      }
    },
    getDateN (date) {
      date = (date < 10) ? (date = '0' + date) : date
      return date
    },
    getOrgList (pram) { // 获取表格数据
      var that = this
      api.post(config.host + 'childMec/getChildMECInfoListWhere.do', pram).then(function (response) {
        that.tableData = response.body.list
        that.total = response.body.page.total
      })
    },
    getList (url, param, key, isOrg) {
      var that = this
      that[key + ''] = []
      api.post(url, param).then(function (response) {
        that[key + ''] = response.body.list
        if (isOrg) {
          that[key + ''].splice(0, 0, {orgKindID: '', fullName: '全部'})
        } else {
          that[key + ''].splice(0, 0, {id: '', name: '全部'})
        }
      })
    },
    selectChange (sel, parentID) { // 下拉框值改变事件
      var self = this
      if (sel === 1) { // 市
        self.formInline.countryID = ''
        self.selectarea = [{id: '', name: '全部'}]
        if (parentID !== '') {
          self.getList(config.host + 'common/getAreasList.do', { 'parentID': parentID }, 'selectarea')
        }
        self.formInline.gardenId = ''
        self.getList(config.host + 'orgkind/getOrgKindListByArea.do', { provinceID: self.formInline.provinceID, // 必须
          cityID: parentID,
          countryID: ''}, 'selectGarden', true)
      } else {
        self.formInline.gardenId = ''
        self.getList(config.host + 'orgkind/getOrgKindListByArea.do', { provinceID: self.formInline.provinceID, // 必须
          cityID: self.formInline.cityID,
          countryID: self.formInline.countryID}, 'selectGarden', true)
      }
    },
    changeYear (val) {
      this.formInline.classYear = val
    },
    doClick(operFunc,index,row){
      switch(operFunc){
       case 'showReporter':this.printShow(index,row);break
       case 'showDetail':this.orgmgrDel(index,row);break
      }
    }
  },
  created () {
    var that = this
    api.post(config.host + 'childMec/getOrgMecYearList.do').then(function (json) {
      that.yearList = json.body.list;
      that.formInline.classYear = that.yearList[0].yearName;
      
      api.post(config.host + 'org/getOrgDetailWithDefault.do').then(function (json) {
        var defaultCountry = json.body.defaultCountry
        var orgInfo = json.body.orgInfo
        that.getId = orgInfo.provinceID
        if (orgInfo.scopeType === 1) {
          that.show.selCity = true
          that.show.selCountry = true
          that.selectcity = [{id: '', name: '全部'}]
          that.selectarea = [{id: '', name: '全部'}]
          that.getList('common/getAreasList.do', { 'parentID': orgInfo.provinceID }, 'selectcity')
          that.getList('common/getAreasList.do', { 'parentID': orgInfo.cityID }, 'selectarea')
          that.getList('orgkind/getOrgKindListByArea.do', {provinceID: orgInfo.provinceID}, 'selectGarden', true)
        } else if (orgInfo.scopeType === 2) {
          that.show.selCountry = true
          that.selectarea = [{id: '', name: '全部'}]
          that.getList('common/getAreasList.do', { 'parentID': orgInfo.cityID }, 'selectarea')
          that.getList('orgkind/getOrgKindListByArea.do', {provinceID: orgInfo.provinceID, cityID: orgInfo.cityID, countryID: defaultCountry.id}, 'selectGarden', true)
        } else if (orgInfo.scopeType === 3) {
          that.getList('orgkind/getOrgKindListByArea.do', {provinceID: orgInfo.provinceID, cityID: orgInfo.cityID, countryID: orgInfo.countryID}, 'selectGarden', true)
        } else {
          that.getList('orgkind/getOrgKindListByArea.do', {}, 'selectGarden', true)
        }
        if (defaultCountry !== undefined) {
          that.formInline.cityID = defaultCountry.parentID
          that.formInline.countryID = defaultCountry.id
        } else {
          that.formInline.cityID = orgInfo.cityID
          that.formInline.countryID = orgInfo.countryID
        }
        that.formInline.provinceID = orgInfo.provinceID
        that.getOrgList(that.formInline)
      })
    })
  },
  mounted(){
    let btnList = window.paramFromParent
    btnList = common.getBtnList(btnList)
    this.generalArea = btnList.generalArea
    this.listArea = btnList.listArea
  }
}
</script>

<style scoped>
.has-gutter tr{
    background:#F5F5F5;
}
.but{
    height: 35px;
    width: 120px;
    border-radius: 6px;
    margin: 10px 0;
    color: #FFF;
    background: #63a0f0;
    border: none;
    cursor: pointer;
}
</style>
<style>
  .el-table th{
    background:#F5F5F5 !important;
  }

  .el-message{
    padding:15px;
    min-width:50px;
  }
</style>


// WEBPACK FOOTER //
// src/components/physical/physical_org.vue